import { render, staticRenderFns } from "./LIcp.vue?vue&type=template&id=56c31078&scoped=true&"
import script from "./LIcp.vue?vue&type=script&lang=js&"
export * from "./LIcp.vue?vue&type=script&lang=js&"
import style0 from "./LIcp.vue?vue&type=style&index=0&id=56c31078&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56c31078",
  null
  
)

export default component.exports